import colors from "../../../common/styles/colors";

export const useIdleModalStyles = () => ({
  title: {
    fontSize: '22px',
    fontWeight: 600
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '20px'
  },
  icon: {
    color: colors.orangeColor1,
    fontSize: '60px !important'
  },
  subtitle: {
    color: colors.darkGrey1,
    fontSize: '14px',
    marginTop: '10px',
    textAlign: 'center'
  },
  buttonContainer: {
    marginTop: '20px',
    '& button': {
      textTransform: "none",
    }
  }
});
